
































































































import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'

export default
    props:
        # all the indices of the movies / series to show in this column
        indices:
            type: Array
            required: true

    computed: {
        ...mapFields('display', {
            'score_review'
            'score_imdb'
            'score_metacritic'
            'time_review'
            'time_release'
            'time_collection'
            'imdbyear'
            'genre'
            'runtime'
            'index'
            'group_by_year'
            'index_type'
            'movies_or_series'
            'layout'
            'topindex'
        })
        entries: ->
            start = window.performance.now()
            data = []

            i = 0
            num_rows = @indices.length
            while i < num_rows
                id = @indices[i]
                elem = @$store.state.data.movies.get(id)
                data.push elem
                i++

            duration = window.performance.now() - start
            if duration > 10
                console.log "Prefetching movies took long (ms) : ", duration
            return data
        are_movies: ->
            return true # XXX not good
    }

    #     are_movies: ->
    #         return true if @is_empty
    #         @entries[0].type == 'Movie'
    #     is_empty: ->
    #         @entries.length == 0
    #     layout: ->
    #         @$store.state.settings.layout
    methods:
        handleClick: (id, event) ->
            console.log event
            if event.ctrlKey
                url = @$store.state.data.movies.get(id).imdb_url
                window.open("https://www.imdb.com/title/#{url}/", '_blank')
            else
                @$router.push({path: "/details/#{id}"})
                # @$store.dispatch 'loadReview', id
        # loadMore: (year) ->
        #     @$store.dispatch 'loadMoreMovies', year
